import { HttpClient, HttpErrorResponse, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  numberPattern = /^[0-9\b]+$/;
  alphabetPattern = /^[a-zA-Z ]*$/;
  numspeccharPattern = /^[0-9@#$%^&*()]+$/;
  alphanumericPattern = /^[a-z0-9 ]+$/i;
  addressPattern = /^[a-z0-9\.\,\/\ ]+$/i;

  sk = "chubblife";

  private loginUrl = environment.baseBackendUrl + '/login';
  private getUserUrl = environment.baseBackendUrl + '/get-user';
  private getUserUrlV2 = environment.baseBackendUrl + '/v2/find/user';
  private getDataDocAgentUrl = environment.baseBackendUrl + '/samba';
  private getDataPDFAgentUrl = environment.baseBackendUrl + '/samba/to-pdf';
  private getDataSLQAgentUrl = environment.baseBackendUrl + '/samba/print-slq';
  private getDataDocStreamUrl = environment.baseBackendUrl + '/samba/stream';
  private getDataListDocPolicyUrl = environment.baseBackendUrl + '/samba/get-list-file';
  private getDataDocPolicyUrl = environment.baseBackendUrl + '/samba/download-policy-pdf';
  private getDataManisUrl = environment.baseBackendUrl + '/efpk/get-manis-data';
  private getAgencyNamesUrl = environment.baseBackendUrl + '/efpk/agency-names';
  private verifyOtpUrl = environment.baseBackendUrl + '/verification/challenge-otp';
  private getAgentSyncUrl = environment.baseBackendUrl + '/agent-sync';
  private saveAgentSyncUrl = environment.baseBackendUrl + '/agent-sync/save';
  private checkEmailPhoneUrl = environment.baseBackendUrl + '/agent-sync/check-email-phone';
  private checkAccountBankUrl = environment.baseBackendUrl + '/agent-sync/check-account-bank';

  constructor(
    private http: HttpClient,
    private router: Router,
  ) { }

  login(loginForm: any) {
    return this.http.post<HttpResponse<any>>(this.loginUrl, loginForm).pipe(catchError(this.handleError));
  }

  verifyOtp(request: any) {
    return this.http.post(this.verifyOtpUrl, request).pipe(catchError(this.handleError));
  }

  getUserData(request: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + sessionStorage.getItem('token')
      })
    };
    return this.http.get(this.getUserUrl, httpOptions).pipe(catchError(this.handleError));
  }

  getUserDataV2(request: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + sessionStorage.getItem('token')
      })
    };
    return this.http.get(this.getUserUrlV2, httpOptions).pipe(catchError(this.handleError));
  }

  getUserDataFind(request: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + sessionStorage.getItem('token')
      })
    };
    return this.http.get(this.getUserUrl + '/' +request, httpOptions).pipe(catchError(this.handleError));
  }


  

  getDataManis() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + sessionStorage.getItem('token')
      })
    };
    return this.http.get(this.getDataManisUrl, httpOptions).pipe(catchError(this.handleError));
  }


  getDataManisAgentCode(dataAgentCode : any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + sessionStorage.getItem('token')
      })
    };
    return this.http.get(this.getDataManisUrl + '/' + dataAgentCode, httpOptions).pipe(catchError(this.handleError));
  }

  getAgentSync(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + sessionStorage.getItem('token')
      })
    };
    return this.http.post(this.getAgentSyncUrl, data, httpOptions).pipe(catchError(this.handleError));
  }

  saveAgentSync(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + sessionStorage.getItem('token')
      })
    };
    return this.http.post(this.saveAgentSyncUrl, data, httpOptions).pipe(catchError(this.handleError2));
  }

  checkEmailPhone(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + sessionStorage.getItem('token')
      })
    };
    return this.http.post(this.checkEmailPhoneUrl, data, httpOptions).pipe(catchError(this.handleError));
  }

  checkAccountBank(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + sessionStorage.getItem('token')
      })
    };
    return this.http.post(this.checkAccountBankUrl, data, httpOptions).pipe(catchError(this.handleError));
  }

  getAgencyNames() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + sessionStorage.getItem('token')
      })
    };
    return this.http.get(this.getAgencyNamesUrl, httpOptions).pipe(catchError(this.handleError));
  }

  getDocumentAgent(data: any) {
    const fileReq = new HttpRequest(
      'POST',
      this.getDataDocAgentUrl,
      data,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }),
        responseType: 'blob'
      },
    );
    return this.http.request(fileReq)
  }


  getDocumentSignature(data: any) {
    const fileReq = new HttpRequest(
      'GET',
      this.getDataDocAgentUrl,
      data,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }),
        responseType: 'blob'
      },
    );
    return this.http.request(fileReq)
  }



  getDocumentToPdfAgent(data: any) {
    const fileReq = new HttpRequest(
      'POST',
      this.getDataPDFAgentUrl,
      data,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }),
        responseType: 'blob'
      },
    );
    return this.http.request(fileReq)
  }


  getSLQToPdfAgent(data: any) {
    const fileReq = new HttpRequest(
      'POST',
      this.getDataSLQAgentUrl,
      data,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }),
        responseType: 'blob'
      },
    );
    return this.http.request(fileReq)
  }


  getDocXml(data: any) {
    const fileReq = new HttpRequest(
      'POST',
      this.getDataDocAgentUrl,
      data,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }),
        responseType: 'text'
      },
    );

    return this.http.request(fileReq)
  }

  getDocumentAgentStream(data: any) {
    const fileReq = new HttpRequest(
      'POST',
      this.getDataDocStreamUrl,
      data,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }),
        responseType: 'blob'
      },
    );

    return this.http.request(fileReq)
  }

  getTiffDokPolicy(data: any) {
    const fileReq = new HttpRequest(
      'POST',
      this.getDataDocAgentUrl,
      data,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }),
        responseType: 'arraybuffer'
      },
    );

    return this.http.request(fileReq)
  }

  getDocumentListFile(data: any) {
    const fileReq = new HttpRequest(
      'POST',
      this.getDataListDocPolicyUrl,
      data,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }),
      },
    );

    return this.http.request(fileReq)
  }

  downloadPolicyPdf(data: any) {
    const fileReq = new HttpRequest(
      'POST',
      this.getDataDocPolicyUrl,
      data,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }),
        responseType: 'blob'
      },
    );

    return this.http.request(fileReq)
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else if (error.status === 401) {
      // this.router.navigate(['login']);
    }
    else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, body was:`, error.error);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }

    private handleError2(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else if (error.status === 401) {
      // this.router.navigate(['login']);
    }
    else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, body was:`, error.error);
            return throwError(error.error);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }

  getDataEncryption(data) {
    const dataEncryption = CryptoJS.AES.encrypt(JSON.stringify(data), this.sk).toString();
    return dataEncryption;
  }

  private getDate(datetimeString) {
    const date = datetimeString.split('T');
    return date[0];
  }

  formatYYYYMMDD(date: Date) {
    return this.getDate(date.toISOString())
  }

  formatDateToLocalFomat(date) {
    let dateLocalFormat = this.getDate(date);
    dateLocalFormat = dateLocalFormat.split('-');
    dateLocalFormat = dateLocalFormat[2] + '-' + dateLocalFormat[1] + '-' + dateLocalFormat[0];
    return dateLocalFormat;
  }

  //dd-MM-yyyy
  formatJsDateToJavaReadableFormat(date: Date) {
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getFullYear();
    let JRF = dd + "/" + mm + "/" + yyyy;
    return JRF;
  }

  formatJsDateToJavaTimeReadableFormat(date: Date) {
    var HH = String(date.getHours()).padStart(2, '0');
    var mm = String(date.getMinutes()).padStart(2, '0');
    var ss = String(date.getSeconds()).padStart(2, '0');
    let JRF = HH + ":" + mm + ":" + ss;
    return JRF;
  }

  formatJsDateToJavaTableFormat(date: Date) {
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getFullYear();
    let JRF = `${yyyy}-${mm}-${dd}`;
    return JRF;
  }

  formatJsDateToEbaoFormat(date: Date) {
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getFullYear();
    let JRF = yyyy + "-" + mm + "-" + dd;
    return JRF;
  }

  prepareJsonForWebApi(object: Object) {
    return {
      'data': this.getDataEncryption(object)
    }
  }

  logout() {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }

  /**
   * Decrypts an EFPKResponse encrypted by the Java AES.encrypt() method.
   *
   * The Java AES.encrypt uses plaintext[8..15] as the salt for key/IV derivation
   * (EVP_BytesToKey). Because EFPKResponse.toString() always starts with
   * "EFPKResponse(references=", bytes [8..15] are always the fixed 8-byte
   * string "onse(ref", and the secret key is a compile-time constant, the
   * resulting AES key and IV are fully deterministic and pre-computed below.
   *
   * The decrypted plaintext is the Lombok @Data toString() representation of
   * EFPKResponse, which this method parses back into a plain JS object.
   */
  decryptJavaAesEncryptedEfpk(encryptedBase64: string): any {
    try {
      // Pre-computed AES-256-CBC key and IV derived from the fixed password
      // ("chubblife") and fixed salt ("onse(ref") via OpenSSL EVP_BytesToKey.
      // Pre-computing avoids runtime hash calls while preserving Java interop.
      const key = CryptoJS.enc.Hex.parse('703760984e44933e9854bb56d0774ce8345c9570051b4af8f966b60423db437c');
      const iv  = CryptoJS.enc.Hex.parse('5555e3a200260f40585058f8a7d17b9e');

      const cipherParams = CryptoJS.lib.CipherParams.create({
        ciphertext: CryptoJS.enc.Base64.parse(encryptedBase64)
      });

      const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

      const plaintext = decrypted.toString(CryptoJS.enc.Utf8);
      return this.parseEfpkLombokToString(plaintext);
    } catch (e) {
      console.error('EFPK decryption error', e);
      return null;
    }
  }

  /**
   * Parses a Lombok @Data toString() string for EFPKResponse into a plain
   * JS object, correctly handling nested objects/lists via depth tracking.
   */
  parseEfpkLombokToString(str: string): any {
    const result: any = {};
    if (!str || !str.startsWith('EFPKResponse(')) return result;

    // Strip class name wrapper: "EFPKResponse(" prefix and trailing ")"
    const inner = str.slice('EFPKResponse('.length, str.lastIndexOf(')'));

    // EFPKResponse fields in Lombok declaration order
    const allFields = [
      'references', 'familyRelated', 'id', 'approvalStatus',
      'distributionOperatorNeedUpdate', 'distributionOperatorNotes',
      'candidateName', 'positionProposed', 'employmentType', 'gender',
      'birthplace', 'birthdate', 'age', 'identityNumber', 'phoneNumber',
      'email', 'isMarried', 'spouse', 'children', 'parentName',
      'citizenship', 'nationality', 'religion', 'npwp', 'npwpNumber',
      'ptkpStatus', 'incomeStatement', 'education', 'branch',
      'leaderIntroducer', 'channelOrganization', 'address', 'rtRw',
      'city', 'zipCode', 'secondaryPhoneNumber', 'housePhone',
      'bankName', 'bankAccountOwner', 'bankAccountNumber',
      'hadWorkedInInsuranceAgency', 'hadPreviousJob', 'previousJob',
      'hadPreviousInsuranceJob', 'spouseWorkedForInsuranceCompany',
      'spouseInsuranceCompanyWorkHistory', 'emergencyContactName',
      'emergencyContactRelation', 'emergencyContactAddress',
      'emergencyContactPhone', 'hasLawViolation', 'lawViolationDetail',
      'documentKtp', 'documentNpwp', 'documentKartuKeluarga',
      'documentBankAccount', 'hasFamilyRelatedEmployee',
      'isAggreeAntiTwistingForm', 'isAggreeContractAgentDocument',
      'hasIntroducer', 'introducer', 'hasAggreeEfpkAggreement',
      'agentCode', 'createdBy', 'dlAgentCode', 'idlAgentCode',
      'publishedStatus', 'isApplicant', 'dateCreated', 'dateUpdated',
      'interviewerAgentCode', 'noLisensiAAJI', 'masaBerlakuAAJI',
      'tanggalLisensiAAJI', 'documentAAJI', 'digitalSignature',
      'digitalSignatureDoa', 'agentDoaName', 'ahliWaris'
    ];

    // Single-pass depth-aware scan to locate each top-level field name.
    // Characters inside nested objects (depth>0) or lists (bracket>0) are skipped,
    // so inner-object fields with the same name are never accidentally matched.
    const fieldPos: { [f: string]: number } = {};
    let depth = 0, bracket = 0;
    for (let k = 0; k < inner.length; k++) {
      const c = inner[k];
      if      (c === '(') { depth++;   continue; }
      else if (c === ')') { depth--;   continue; }
      else if (c === '[') { bracket++; continue; }
      else if (c === ']') { bracket--; continue; }

      if (depth === 0 && bracket === 0) {
        for (const f of allFields) {
          if (fieldPos[f] === undefined && inner.startsWith(f + '=', k)) {
            fieldPos[f] = k;
            break;
          }
        }
      }
    }

    // Extract each field's value using the recorded top-level positions
    for (let i = 0; i < allFields.length; i++) {
      const field = allFields[i];
      const pos   = fieldPos[field];
      if (pos === undefined) continue;

      const valueStart = pos + field.length + 1; // +1 for '='
      const nextField  = allFields[i + 1];
      let   valueEnd: number;

      if (nextField !== undefined && fieldPos[nextField] !== undefined) {
        valueEnd = fieldPos[nextField] - 2; // -2 for the ", " separator
      } else {
        valueEnd = inner.length;
      }

      const val = inner.substring(valueStart, valueEnd);
      result[field] = val === 'null' ? null : val;
    }

    return result;
  }

}
